import { observer } from 'mobx-react-lite';
import { contentPaneLabel } from 'owa-locstrings/lib/strings/contentpanelabel.locstring.json';
import loc from 'owa-localize';
import Compose from './Compose';
import Dock from './Dock';
import { createInitialActions, executeInitialActions, InitialActions } from 'owa-initial-actions';
import { ComposeViewState } from 'owa-mail-compose-store';
import * as React from 'react';

const styles = require('./FullCompose.scss');
const classNames = require('classnames');

export interface FullComposeProps {
    viewState: ComposeViewState;
    sxsId?: string;
    isSxS?: boolean;
}

export default observer(function FullCompose(props: FullComposeProps) {
    React.useEffect(() => {
        executeInitialActions(initialActions.current);
    }, []);
    const initialActions = React.useRef<InitialActions>(createInitialActions());
    const viewState = props.viewState;
    const { sxsId, isSxS } = props;
    const scrollContainerClasses = classNames(styles.scrollContainer, 'customScrollBar');
    return (
        <div tabIndex={-1} role={'main'} aria-label={loc(contentPaneLabel)}>
            <Compose
                viewState={viewState}
                className={scrollContainerClasses}
                sxsId={sxsId}
                isSxS={isSxS}
                initialActions={initialActions.current}>
                <div className={styles.scrollRegionBottomBuffer} />
            </Compose>
            <Dock viewState={viewState} initialActions={initialActions.current} />
        </div>
    );
});
